import React, {Component} from 'react';
import BarChart from '../BarChart';
import './FuelReport.css';

class FuelReport extends Component{
    state={
    }

    componentDidMount() {
        window.$('.rw-container').css('top', '53px');
    }

    componentWillUnmount() {
        // window.$('.rw-container').css('top', null);
        window.$('.rw-container').attr('style', function(i, style)
        {
            return style && style.replace(/top[^;]+;?/g, '');
        });
    }

    render(){
        return(
            <div className='fuelReport'>
                Fuel Report
            </div>
        )
    }
}

export default FuelReport;